import { BoomForm } from "boomform";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import App from "./app";
import * as serviceWorker from "./serviceWorker";
import { persistor, store } from "./store";

import "react-toastify/dist/ReactToastify.css";
import "./index.css";

const root = document.getElementById("root");

ReactDOM.render(
    <React.StrictMode>
        <BoomForm fields={[]}>
            {({ declareFields, updateId, handleChange }) => {
                window.declareFields = declareFields;
                window.updateId = updateId;
                window.handleChange = handleChange;
                window.blockFieldUpdate = 0;

                return (
                    <Provider store={store}>
                        <PersistGate persistor={persistor}>
                            <Router>
                                <App />
                                {/* <HardReset /> */}
                            </Router>
                        </PersistGate>
                    </Provider>
                );
            }}
        </BoomForm>
        <ToastContainer
            hideProgressBar={true}
            autoClose={6000}
            pauseOnFocusLoss={false}
            limit={6}
            position={toast.POSITION.TOP_RIGHT}
        />
    </React.StrictMode>,
    root,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
